import { Plus } from "@untitledui/icons";
import { useState } from "react";
import { Button } from "@/components/base/buttons/button";
import { ComboBox } from "@/components/base/select/combobox";
import { Select } from "@/components/base/select/select";

const CREATE_KEY = "__create__";

type CustomRiskAdderProps = {
  search: string;
  onSearchChange: (value: string) => void;
  options: { id: string; label: string }[];
  onSelect: (key: string | number | null) => void;
  onCreateNew: (name: string) => void;
};

// Rendered as the last block inside the "Custom risk" group accordion. A single
// button that expands into a combobox: picking an existing option attaches it,
// while the trailing create item stages a brand-new risk named after the search.
export const CustomRiskAdder = ({ search, onSearchChange, options, onSelect, onCreateNew }: CustomRiskAdderProps) => {
  const [isAdding, setIsAdding] = useState(false);

  const close = () => {
    setIsAdding(false);
    onSearchChange("");
  };

  const handleSelect = (key: string | number | null) => {
    if (key == null) return;
    if (key === CREATE_KEY) onCreateNew(search.trim());
    else onSelect(key);
    close();
  };

  const term = search.trim();
  const items = [...options, { id: CREATE_KEY, label: term ? `Create "${term}"` : "Create new custom risk" }];

  return (
    <div className="px-6 py-5 border-t border-secondary first:border-t-0">
      {isAdding ? (
        <ComboBox
          aria-label="Add custom risk"
          placeholder="Search custom risks or create a new one…"
          shortcut={false}
          autoFocus
          defaultOpen
          inputValue={search}
          onInputChange={onSearchChange}
          selectedKey={null}
          onSelectionChange={handleSelect}
          onBlur={close}
          items={items}
          allowsEmptyCollection
        >
          {(item) => <Select.Item id={item.id}>{item.label}</Select.Item>}
        </ComboBox>
      ) : (
        <Button color="primary" iconLeading={Plus} onClick={() => setIsAdding(true)}>
          Add custom risk
        </Button>
      )}
    </div>
  );
};
